import { render, staticRenderFns } from "./selectProject.vue?vue&type=template&id=2bca6594&scoped=true&"
import script from "./selectProject.vue?vue&type=script&lang=js&"
export * from "./selectProject.vue?vue&type=script&lang=js&"
import style0 from "./selectProject.vue?vue&type=style&index=0&id=2bca6594&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca6594",
  null
  
)

export default component.exports